import { lazy } from "react";

export const AusOverseas = lazy(() => import("./AusOverseas"));
export const AmlBlog = lazy(() => import("./AmlBlog"));

export const FxRateBlog = lazy(() => import("./FxRateBlog"));
export const MidMarketBlog = lazy(() => import("./MidMarket"));

export const InternationalMoney = lazy(() => import("./InternationalMoney"));
export const CashRemittanceBlog = lazy(() => import("./CashRemittance"));

export const SpecialBlog = lazy(() => import("./SpecialBlog"));
